import { FC } from "react";

interface DividerBlockProps {
	id?: string;
}

// A short centred accent rule rather than a full-width hairline: it reads as a deliberate
// section break between two authored pieces, and does not compete with the left-hand rule
// the pull quote already uses.
const DividerBlock: FC<DividerBlockProps> = ({ id }) => (
	<hr id={id} className="mx-auto w-16 h-0.5 border-0 rounded bg-primary" />
);

export { DividerBlock };
